<scaffold-dialog [fit]="true" title="Sync To LMS">
  <div scaffoldDialogBody>
    <div class="sync-wizard">
      <div class="sync-wizard__steps">
        <div
          class="sync-step"
          [class.sync-step--active]="step === 1"
          [class.sync-step--complete]="step > 1">
          <span class="sync-step__index">
            <i class="fa-solid fa-check" *ngIf="step > 1"></i>
            <ng-container *ngIf="step <= 1">1</ng-container>
          </span>
          <span class="sync-step__label">Choose Integration</span>
        </div>
        <div
          class="sync-step__connector"
          [class.sync-step__connector--active]="step > 1"></div>
        <div
          class="sync-step"
          [class.sync-step--active]="step === 2"
          [class.sync-step--complete]="false">
          <span class="sync-step__index">2</span>
          <span class="sync-step__label">Append Settings</span>
        </div>
      </div>

      <div class="sync-wizard__panel" *ngIf="step === 1">
        <div class="align-center fa-2x" *ngIf="loading">
          <scaffold-loading-animation></scaffold-loading-animation>
        </div>

        <div *ngIf="integrations && integrations.length > 0">
          <p class="sync-wizard__hint">Select an integration to continue.</p>
          <div class="sync-wizard__toolbar">
            <div class="sync-wizard__filter" *ngIf="integrations.length > 4">
              <span class="p-input-icon-left">
                <i class="fa-thin fa-magnifying-glass"></i>
                <input
                  pInputText
                  fluid
                  placeholder="Filter Integrations"
                  [(ngModel)]="filterText"
                  (ngModelChange)="filterIntegrations()" />
              </span>
            </div>
            <button
              pButton
              type="button"
              variant="outlined"
              severity="secondary"
              class="sync-wizard__refresh"
              [disabled]="loading"
              (click)="refreshIntegrations()"
              pTooltip="Refresh integrations"
              aria-label="Refresh integrations">
              <i
                class="fa-regular fa-arrows-rotate"
                [class.sync-wizard__refresh-icon--loading]="loading"></i>
            </button>
          </div>

          <div class="sync-wizard__list">
            <div
              class="integration-select-container"
              *ngFor="let integration of filteredIntegrations">
              <scaffold-integration-banner
                [integration]="integration"
                (bannerClicked)="selectIntegration($event)"
                (click)="selectIntegration(integration)"
                [selected]="selectedIntegration === integration"
                [selectable]="true"
                [syncDetails]="true"
                [showInfoIcon]="true"></scaffold-integration-banner>
            </div>
          </div>

          <div
            *ngIf="filteredIntegrations.length === 0"
            class="sync-wizard__empty">
            <label>{{
              'no_integrations_match_filter'
                | translation
                | translationFromString
                | transformText: 'capitalize'
            }}</label>
          </div>
        </div>

        <div
          *ngIf="integrations && integrations.length === 0 && !loading"
          class="sync-wizard__empty">
          <label
            >{{
              getNoIntegrationMessage()
                | translation
                | translationFromString
                | transformText: 'capitalize'
            }}
          </label>
        </div>
      </div>

      <div class="sync-wizard__panel" *ngIf="step === 2">
        <div class="sync-summary" *ngIf="selectedIntegration as integration">
          <div class="sync-summary__icon">
            <img
              [src]="getLogo(integration) | safe"
              (error)="onLogoError($event)"
              alt="integration logo" />
          </div>
          <div class="sync-summary__info">
            <div class="sync-summary__name">
              {{ integration.friendly_name }}
            </div>
            <div class="sync-summary__type">
              {{ integration.integration_type | transformText: 'uppercase' }}
            </div>
          </div>
          <button
            pButton
            variant="text"
            severity="secondary"
            size="small"
            class="sync-summary__change"
            (click)="prevStep()">
            <i class="fa-solid fa-arrow-left"></i>
            <span>Change</span>
          </button>
        </div>

        <div class="sync-append">
          <div class="sync-append__header">
            <h3 class="sync-append__title">Append to Course Title</h3>
            <p class="sync-append__hint">
              Review the title text used when this sync creates a new LMS
              course.
            </p>
          </div>

          <div class="sync-append__field">
            <label class="sync-append__label">Where should the text go?</label>
            <div class="sync-append__selectbutton">
              <p-selectbutton
                [options]="appendTypeOptions"
                [(ngModel)]="appendType"
                optionLabel="label"
                optionValue="value"
                [allowEmpty]="true"></p-selectbutton>
            </div>
          </div>

          <div class="sync-append__field">
            <label class="sync-append__label">Text to append</label>
            <input
              pInputText
              fluid
              [(ngModel)]="appendToCourse"
              placeholder="Enter text to append"
              [class.sync-append__input--error]="
                hasIncompleteAppendSettings()
              " />
          </div>

          <div class="sync-append__error" *ngIf="hasIncompleteAppendSettings()">
            <i class="fa-solid fa-circle-exclamation"></i>
            Set both where the text goes and the text to append, or leave both
            empty.
          </div>

          <div class="sync-preview" *ngIf="hasAppendPreview">
            <span class="sync-preview__label">Resulting title</span>
            <div class="sync-preview__title">{{ previewTitle }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div scaffoldDialogButtons>
    <button
      pButton
      variant="outlined"
      severity="secondary"
      (click)="closeDialog()">
      Cancel
    </button>

    <ng-container *ngIf="step === 2">
      <button
        pButton
        variant="outlined"
        severity="secondary"
        (click)="prevStep()">
        <i class="fa-solid fa-arrow-left"></i>
        <span>Back</span>
      </button>
      <p-buttongroup *ngIf="selectedIntegration?.has_course">
        <button
          pButton
          severity="primary"
          [disabled]="!canSyncSelected()"
          (click)="select(true)"
          pTooltip="If this course has previously been synced, this will create a new copy of the course instead of updating the existing one.">
          Sync As New Course
        </button>
        <button
          pButton
          severity="primary"
          [disabled]="!canSyncSelected()"
          (click)="select(false)">
          Sync Selected
        </button>
      </p-buttongroup>
      <button
        *ngIf="!selectedIntegration?.has_course"
        pButton
        severity="primary"
        [disabled]="!canSyncSelected()"
        (click)="select(false)">
        Sync Selected
      </button>
    </ng-container>
  </div>
</scaffold-dialog>
